const shadows = {};

export default shadows;
